'use client';

import SearchIcon from '@mui/icons-material/Search';
import { Box, Typography } from '@mui/material';

interface SearchNoResultsProps {
  query: string;
}

export const SearchNoResults = ({ query }: SearchNoResultsProps) => (
  <Box sx={{ py: 10, textAlign: 'center' }}>
    <SearchIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 2 }} />
    <Typography variant="h6" sx={{ color: 'text.primary', mb: 1 }}>
      No results found
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
      We couldn't find any markets or profiles matching "{query}"
    </Typography>
  </Box>
);
